import { cache } from "react";
import { createMagentoClient } from "~/graphql";
import type { CategoryGenqlSelection } from "../genql/magento";

export const CategoryFragment = {
	id: true,
	name: true,
	url: true,
	image: true,
	isUsedForSeo: true,
} satisfies CategoryGenqlSelection;

type getCategoryPageReturn = Awaited<ReturnType<typeof getCategoryPage>>;

export type CategoryPageType = NonNullable<getCategoryPageReturn["category"]>;
export type FilterableAttributesType = getCategoryPageReturn["filterableAttributes"];

export const getCategoryPage = cache(async (id: string, lang: string) => {
	return createMagentoClient(lang).query({
		__name: "getCategoryPage",
		category: {
			__args: { id },
			id: true,
			name: true,
			image: true,
			url: true,
			description: true,
			metaTitle: true,
			metaDescription: true,
			metaKeywords: true,
			seoContent: true,
			displayType: true,
			isUsedForSeo: true,
			hrefLang: {
				hreflang: true,
				href: true,
			},
			parent: {
				children: {
					...CategoryFragment,
				},
			},
			children: {
				...CategoryFragment,
			},
			parents: {
				id: true,
				name: true,
				url: true,
			},
		},
		filterableAttributes: true,
		products: {
			__args: {
				currentPage: 1,
				filter: { category_id: id, type_id: "grouped" },
				sort: { name: "ASC" },
				pageSize: 50,
			},
			items: {
				id: true,
				name: true,
				image: true,
				imageBase: true,
				imageDetail: true,
				url: true,
				isSalable: true,
				associatedProducts: {
					items: {
						id: true,
						url: true,
						thickness: true,
						isSalable: true,
					},
				},
			},
		},
	});
});

export type TaxonomyProductsType = NonNullable<Awaited<ReturnType<typeof getCategoryPage>>>;
